/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-container fluid grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 hidden-md-and-up v-for="(item, idx) in items" :key="'A' + idx">
          <Card class="ana-card">
          <div @click="item.component!= 'plant_static_info' ? $router.push(`${item.path}`) : myFunction()" v-if="item.name == 'Inverter' || item.name == 'Weather Station'">
            <div><v-icon x-large color="#fff">description</v-icon></div>
            <div class="ana-card-text">{{item.name}}</div>
          </div>
          </Card>
        </v-flex>
        <v-flex xs6 sm6 md3 hidden-md-and-down v-for="(item, idx) in items" :key="'B' + idx">
          <Card class="ana-card">
          <div @click="item.component!= 'plant_static_info' ? $router.push(`${item.path}`) : myFunction()">
            <div><v-icon x-large>description</v-icon></div>
            <div class="ana-card-text">{{item.name}}</div>
          </div>
        </Card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { EventBus } from '@/services/event-bus'
import { mapGetters } from 'vuex'
import Card from "@/components/common/Cards.vue"
export default {
    components: {
    Card
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getRules', 'getActivePlantInfo'])
  },
  data() {
    return {
      items: [],
      componentKey: 0
    }
  },
  mounted() {
    const pathModule = this.$router.currentRoute.path.split('/')[2]
    this.getComponents(pathModule)
    EventBus.$on('plantChanged', this.plantChange)
  },
  methods: {
    // Open New Window To Display PDF
    myFunction: function() {
      window.open(this.getActivePlantInfo('staticInfo'))
    },

    plantChange() {
      const pathModule = this.$router.currentRoute.path.split('/')[2]
      this.getComponents(pathModule)
    },

    getComponents(pathModule) {
      const accessModule = this.getRules(['rule', 'access_config', `${pathModule}`])
      accessModule && Object.keys(accessModule).length > 1 ? (this.items = accessModule) : this.$router.push(accessModule[0].path)
      this.componentKey += 1
    }
  },

  beforeDestroy() {
    EventBus.$off('plantChanged', this.plantChange)
  },

  watch: {
    $route(to, from) {
      const pathModule = to.path.split('/')[2]
      this.getComponents(pathModule)
    }
  }
}
</script>
<style scoped>
.ana-card {
  cursor: pointer;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.ana-card-text {
  font-size: 18px;
  font-weight: 500;
  height: 50px;
}

</style>
